(() => {
  const familyLabel = family => window.vivicoFamilyNames?.[family] || family;
  const families = ['Snap Case', 'Tough Magnetic Case', 'Flexi Case', 'Magnetic Clear Impact Case'];
  const matchesBrand = (model, brand) => brand === 'apple' ? /iphone/i.test(model) : /galaxy|samsung/i.test(model);
  const generation = m => Number(m.match(/\d+/)?.[0] || (/iphone x/i.test(m) ? 10 : 0));
  const sortModels = (a, b) => generation(b) - generation(a) || b.localeCompare(a, document.documentElement.lang || 'en', {numeric: true});
  class VivicoDeviceMenu extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = JSON.parse(document.getElementById('vivico-device-data')?.textContent || '[]');
      this.brand = 'apple'; this.family = families[0];
      this.querySelectorAll('[data-brand]').forEach(button => button.addEventListener('click', () => {
        this.brand = button.dataset.brand;
        this.querySelectorAll('[data-brand]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        if (!this.models(this.family).length) this.family = families.find(f => this.models(f).length);
        this.render();
      }));
      this.render();
    }
    models(family) { return [...new Set(this.items.filter(i => i.family === family).flatMap(i => i.models).filter(m => matchesBrand(m, this.brand)))].sort(sortModels); }
    link(model, family) {
      const a = document.createElement('a'); const url = new URL(this.dataset.base, location.origin);
      url.searchParams.set('brand', this.brand); url.searchParams.set('model', model.toLowerCase());
      if (this.dataset.kind === 'case') url.searchParams.set('family', family);
      a.href = url.pathname + url.search; a.textContent = model; return a;
    }
    render() {
      const target = this.querySelector('[data-model-links]'); target.replaceChildren();
      if (this.dataset.kind !== 'case') { this.models('Cover-Up').forEach(m => target.append(this.link(m, 'Cover-Up'))); return; }
      const familyTarget = this.querySelector('[data-families]'); familyTarget.replaceChildren();
      families.forEach(family => {
        const models = this.models(family); const button = document.createElement('button');
        button.type = 'button'; button.textContent = familyLabel(family); button.disabled = !models.length;
        button.setAttribute('aria-pressed', String(this.family === family));
        if (!models.length) button.title = this.dataset.unavailable || 'Currently unavailable for this brand';
        button.addEventListener('click', () => { this.family = family; this.render(); this.querySelector('[data-families] button[aria-pressed="true"]').focus(); });
        familyTarget.append(button);
      });
      this.models(this.family).forEach(m => target.append(this.link(m, this.family)));
      // Mobile accordion: each case exposes its own compatible models.
      this.querySelector('.v-mobile-accordion')?.remove();
      const accordion = document.createElement('div'); accordion.className = 'v-mobile-accordion';
      families.forEach(family => {
        const models = this.models(family); if (!models.length) return;
        const details = document.createElement('details'); const summary = document.createElement('summary');
        summary.textContent = familyLabel(family); details.append(summary);
        const links = document.createElement('div'); links.className = 'v-menu-models';
        models.forEach(m => links.append(this.link(m, family))); details.append(links); accordion.append(details);
      });
      this.append(accordion);
    }
  }
  if (!customElements.get('vivico-device-menu')) customElements.define('vivico-device-menu', VivicoDeviceMenu);
})();
